import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import style from './index.scss';
//todo: Refactor this for NS
const StatusFilterForNS = (props) => {
  const { statusData, filterData, activeIndex, handleClick } = props;

  if (
    !statusData ||
    !filterData ||
    activeIndex === null ||
    activeIndex === undefined
  ) {
    return null;
  }

  let spanElements = [];
  statusData.forEach((status, i) => {
    spanElements.push(
      <span
        key={`${status.text}-${i}`}
        className={classnames(
          style.presetSpan,
          activeIndex == i ? style.presetSpanActive : ''
        )}
        onClick={() => {
          handleClick(i);
        }}>
        {status.text}
        <small> ({filterData[status.name]})</small>
      </span>
    );
  });

  return <div className={style.statusFilter}>{spanElements}</div>;
};

StatusFilterForNS.propTypes = {
  statusData: PropTypes.array,
  filterData: PropTypes.object.isRequired,
  activeIndex: PropTypes.number,
  handleClick: PropTypes.func
};

const SubstatusFilterForNS = (props) => {
  const { statusData, filterData, activeIndex, handleClick } = props;

  if (
    !statusData ||
    !filterData ||
    activeIndex === null ||
    activeIndex === undefined
  ) {
    return null;
  }

  let spanElements = [];
  statusData.forEach((status, i) => {
    spanElements.push(
      <span
        key={`${status.text}-${i}`}
        className={classnames(
          style.presetSpanSubstatus,
          activeIndex == i ? style.presetSpanSubstatusActive : ''
        )}
        onClick={() => {
          handleClick(i);
        }}>
        <i
          className={classnames(style.dotIndicator)}
          style={{ background: indicatorColorGenerator(status.name) }}></i>
        &nbsp;{status.text}
        <small> ({filterData[status.name]})</small>
      </span>
    );
  });

  return <div className={style.statusFilter}>{spanElements}</div>;
};

SubstatusFilterForNS.propTypes = {
  statusData: PropTypes.array,
  filterData: PropTypes.object.isRequired,
  activeIndex: PropTypes.number,
  handleClick: PropTypes.func
};

const indicatorColorGenerator = (s) => {
  if (s == 'alert') {
    return '#E85252';
  }

  if (s == 'anomaly' || s == 'anomlay') {
    return '#BC23DA';
  }

  return '#fff';
};

export { StatusFilterForNS, SubstatusFilterForNS };
